import { render, staticRenderFns } from "./HistoricoAtendimentos.vue?vue&type=template&id=1130cc26&scoped=true&"
import script from "./HistoricoAtendimentos.vue?vue&type=script&lang=js&"
export * from "./HistoricoAtendimentos.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoAtendimentos.vue?vue&type=style&index=0&id=1130cc26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1130cc26",
  null
  
)

export default component.exports